import { useConfig } from './config.context';

export const useScreensConfig = () => {
  return useConfig()?.screens;
};

export function useScreenConfig(name) {
  const screenConfig = useScreensConfig();
  return screenConfig?.[name] ?? {};
}
